import { currencyConversion } from './helpers.js'

export const growthOptionsVar = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 30,
      right: 35
    }
  },
  scales: {
    y: {
      ticks: {
        padding: 5,
        font: {
          size: 14
        },
        callback: function (value, index, ticks) {
          if ((index % 2) === 0) {
            return currencyConversion(value)
          } else {
            return ''
          }
        }
      }
    },
    x: {
      grid: {
        tickLength: 15
      },
      ticks: {
        font: {
          size: 14
        }
      }
    }
  },
  plugins: {
    legend: false,
    title: false,
    tooltip: false
  }

}

export function chunkify (a, n, balanced) {
  if (n < 2) { return [a] }

  const len = a.length
  const out = []
  let i = 0
  let size

  if (len % n === 0) {
    size = Math.floor(len / n)
    while (i < len) {
      out.push(a.slice(i, i += size))
    }
  } else if (balanced) {
    while (i < len) {
      size = Math.ceil((len - i) / n--)
      out.push(a.slice(i, i += size))
    }
  } else {
    n--
    size = Math.floor(len / n)
    if (len % size === 0) { size-- }
    while (i < size * n) {
      out.push(a.slice(i, i += size))
    }
    out.push(a.slice(size * n))
  }

  return out
}

export function formatCreditGrowthArray (principalLimitGrowthArray) {
  principalLimitGrowthArray = chunkify(principalLimitGrowthArray, 4, true)
  const formattedGrowthArray = [
    principalLimitGrowthArray[0][0],
    principalLimitGrowthArray[0].slice(-1)[0],
    principalLimitGrowthArray[1].slice(-1)[0],
    principalLimitGrowthArray[2].slice(-1)[0],
    principalLimitGrowthArray[3].slice(-1)[0]
  ]
  return formattedGrowthArray
}

export function getCreditGrowth (principalLimitGrowthArray) {
  const formattedGrowthArray = formatCreditGrowthArray(principalLimitGrowthArray)

  return formattedGrowthArray[4]['Principal Limit']
}

export function getPrincipleLimitGrowth (principalLimitGrowthArray) {
  const formattedGrowthArray = formatCreditGrowthArray(principalLimitGrowthArray)
  const principleLimitGrowth = formattedGrowthArray.map(function (d) {
    return d['Principal Limit']
  })
  return principleLimitGrowth
}

export function getXLabels (youngestBorrowerAge) {
  const xLabels = [
    'Age ' + parseInt(youngestBorrowerAge),
    'Age ' + (parseInt(youngestBorrowerAge) + 5),
    'Age ' + (parseInt(youngestBorrowerAge) + 10),
    'Age ' + (parseInt(youngestBorrowerAge) + 15),
    'Age ' + (parseInt(youngestBorrowerAge) + 20)
  ]
  return xLabels
}

export const chartDataVar = {
  labels: [],
  datasets: [{
    labels: [],
    type: 'line',
    pointBackgroundColor: '#0e1e3b',
    pointBorderColor: '#0e1e3b',
    pointRadius: 4,
    borderColor: '#6cae17',
    borderWidth: 4,
    fill: false,
    data: [],
    datalabels: {
      anchor: 'center',
      clamp: false,
      align: 'top',
      offset: 10,
      color: '#fff',
      backgroundColor: 'rgba(11, 24, 47, 0.8)',
      borderRadius: 6,
      padding: 6,
      formatter: function (value, context) {
        return currencyConversion(value) || null
      }
    }

  }]
}
